import axios from 'axios';
import React from 'react';
import {Button, Grid, CircularProgress, Typography, Divider, Stack, Box, TextField, FormControlLabel, Switch, RadioGroup, Radio, FormControl, FormLabel, Select, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import * as ETVConstants from '../ETVConstants';
import { Delete, Edit, Lock, CheckCircle, Block, Photo, Add, Person } from '@mui/icons-material';
import CardAccessMgmt from './CardAccessMgmt';
import Autocomplete from '@mui/material/Autocomplete';
import Phototaker from '../tools/Phototaker';
import PhotoThumb from '../tools/PhotoThumb';
import ETVPage from '../tools/ETVPage';
import ETVPopup from '../tools/ETVPopup';
import ETVMessagePopup from '../tools/ETVMessagePopup';
import ETVActionButton from '../tools/ETVActionButton';

class CardMgmt extends React.Component {

  constructor(props) {
    super(props);
    this.uploadPhotos = this.uploadPhotos.bind(this);
    this.closeInfoMessage = this.closeInfoMessage.bind(this);
  }

  state = {
    locations:[],
    cards:[],
    locationsLoaded:false,
    cardsLoaded: false,
    cardSearch: '',
    selected_card_id:undefined,
    selected_location_id:undefined,

    // dialog state
    window: '',
    action: undefined,
    card_id: '',
    name: '',
    active: true,

    // validity controls
    validityMode: 'never',   // 'never' | 'temporary' | 'date'
    tempMinutes: 15,         // one of [5,15,30,60,120,240]
    dateLocal: '',           // 'YYYY-MM-DDTHH:mm' for <input type="datetime-local">

    info_title: undefined,
    info_message: undefined,
  }

  componentDidUpdate() {
    if(!this.state.cardsLoaded && !this.state.cardsLoading && this.state.selected_location_id) {
      this.loadCards();
    }
  }

  componentDidMount() {
    this.loadLocations();
  }

  loadLocations() {
    this.setState({loadingLocations:true});
    var url = ETVConstants.getServerBase()+"/floor_access?action=get_locations&user_id="+this.props.user_id;
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {
          var locID = undefined;
          if(result.list.length===1) {
            locID = result.list[0].location_id;
          }
          this.setState({
            locations: result.list,
            locationsLoaded: true,
            loadingLocations:false,
            selected_location_id: locID,
          });
        },
        (error) => {
          this.setState({
            locations:[],
            locationsLoaded: false,
            loadingLocations:false,
            error
          });
        }
      )
  }

  loadCards() {
    this.setState({cardsLoading:true});
    var accessToken = localStorage.getItem("etv.access_token");
    var reqUserID = localStorage.getItem("etv.user_id");
    var url = ETVConstants.getServerBase()+"/floor_access?action=get_cards&location_id="+this.state.selected_location_id+"&issuer_id="+reqUserID;
    //console.log("load cards url="+url);
    fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
      .then(res => res.json())
      .then(
        (result) => {
          //console.log(JSON.stringify(result));
          this.setState({
            cards: result.list,
            cardsLoaded: true,
            cardsLoading: false,
          });
        },
        (error) => {
          this.setState({
            cards:[],
            cardsLoaded: false,
            cardsLoading: false,
            error
          });
        }
      )
  }


  getCard( cardID) {
    for(var i=0; i<this.state.cards.length; i++) {
      if(this.state.cards[i].card_id===cardID) {
        return this.state.cards[i];
      }
    }
    return null;
  }

  showWindow(divID, show) {
    show?this.setState({window:divID}):this.setState({window:''});
  }

	showInfoMessage(title,msg,isSpinning) {
		this.setState({window:'message_div',info_type:'info',info_title:title,info_message:msg,spinning:isSpinning});
	}

  showSuccessMessage(title,msg) {
	  	this.setState({window:'message_div',info_type:'success',info_title:title,info_message:msg,spinning:false});
	}

	showErrorMessage(title,msg) {
	  	this.setState({window:'message_div',info_type:'error',info_title:title,info_message:msg,spinning:false});
	}

  closeInfoMessage() {
	 	this.setState({window:'',info_type:'',info_title:'',info_message:undefined,spinning:false});
  }


  addCard() {
    this.setState({
      window: 'add_card_div',
      action: 'add_card',
      card_id:'',
      name: '',
      active:true,
      validityMode: 'never',
      tempMinutes: 15,
      dateLocal: '',
    });
  }

    editCard(cardID) {
      const card = this.state.cards.find(c => c.card_id === cardID);
      if (card) {
        const existingValidUntil = (card.valid_until || '').trim(); // expect '' or 'yyyy-MM-dd HH:mm +0000'
        // If a valid_until exists, prefill the date picker in local time and set mode 'date'
        let validityMode = 'never';
        let dateLocal = '';
        if (existingValidUntil !== '') {
          const dt = this.parseEtvUtcStringToDate(existingValidUntil); // Date (UTC-based)
          if (dt) dateLocal = this.toLocalDatetimeLocalValue(dt);      // convert to local 'YYYY-MM-DDTHH:mm'
          validityMode = 'date';
        }
        this.setState({
          window:'add_card_div',
          card_id: card.card_id,
          action: 'update_card',
          name: card.name,
          active: card.active,
          validityMode,
          tempMinutes: 15,
          dateLocal,
        });
      }
    }


    // Format Date -> 'yyyy-MM-dd HH:mm +0000' (force UTC)
    formatUtcForServer(dateObj) {
      const pad = (n) => (n<10? '0'+n : ''+n);
      const y = dateObj.getUTCFullYear();
      const m = pad(dateObj.getUTCMonth()+1);
      const d = pad(dateObj.getUTCDate());
      const hh = pad(dateObj.getUTCHours());
      const mm = pad(dateObj.getUTCMinutes());
      return `${y}-${m}-${d} ${hh}:${mm} +0000`;
      // We always send +0000 (UTC)
    }

    // Parse 'yyyy-MM-dd HH:mm ±HHMM' -> Date in UTC
    parseEtvUtcStringToDate(s) {
      const re = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}) ([+-]\d{4})$/;
      const m = s.match(re);
      if (!m) return null;
      const [_, ys, ms, ds, hs, mins, off] = m;
      const y = parseInt(ys, 10);
      const mo = parseInt(ms, 10);
      const d = parseInt(ds, 10);
      const h = parseInt(hs, 10);
      const mi = parseInt(mins, 10);
      const sign = off[0] === '-' ? -1 : 1;
      const offHours = parseInt(off.substring(1,3), 10);
      const offMins  = parseInt(off.substring(3,5), 10);
      const totalOffsetMin = sign * (offHours*60 + offMins);

      // Date.UTC gives time as if in UTC; adjust by offset to get actual UTC ms
      const msUTC = Date.UTC(y, mo-1, d, h, mi) - (totalOffsetMin * 60 * 1000);
      return new Date(msUTC);
    }

    // Convert Date -> 'YYYY-MM-DDTHH:mm' in local time for <input type="datetime-local">
    toLocalDatetimeLocalValue(dateObj) {
      const pad = (n) => (n<10? '0'+n : ''+n);
      const y = dateObj.getFullYear();
      const m = pad(dateObj.getMonth()+1);
      const d = pad(dateObj.getDate());
      const hh = pad(dateObj.getHours());
      const mm = pad(dateObj.getMinutes());
      return `${y}-${m}-${d}T${hh}:${mm}`;
    }

    // Compute valid_until param based on the current UI state
    computeValidUntilParam() {
      const { validityMode, tempMinutes, dateLocal } = this.state;

      if (validityMode === 'never') {
        return '';
      }

      if (validityMode === 'temporary') {
        const now = new Date();
        const expiry = new Date(now.getTime() + tempMinutes * 60 * 1000);
        return this.formatUtcForServer(expiry);
      }

      // validityMode === 'date' -> parse local datetime-local, convert to UTC string
      if (!dateLocal) return ''; // if empty, treat as never
      // dateLocal like 'YYYY-MM-DDTHH:mm' (local)
      const localDate = new Date(dateLocal); // interpreted as local time by browser
      if (isNaN(localDate.getTime())) return '';

      return this.formatUtcForServer(localDate);
    }

    submitAddCard() {
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      const { card_id, name, active } = this.state;
      const validUntilToSend = this.computeValidUntilParam();
      var url = ETVConstants.getServerBase()+"/floor_access?action=add_card";
      url+="&card_id="+encodeURIComponent(card_id);
      url+="&name="+encodeURIComponent(name);
      url+="&active="+active;
      url+="&issuer_id="+reqUserID;
      url+="&location_id="+this.state.selected_location_id;
      url+="&valid_until="+encodeURIComponent(validUntilToSend);
      fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then((result) => {
          this.setState({ window: '', cardsLoaded: false }); 
        })
        .catch((error) => {
          this.showErrorMessage("Error", "Failed to save floor");
        });
    }

    deleteCard(cardID) {
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      var url = ETVConstants.getServerBase()+"/floor_access?action=delete_card";
      url+="&card_id="+cardID;
      //console.log("delete URL="+url);
      fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then((result) => {
          this.setState({ window: '', cardsLoaded: false }); // reload table
        })
        .catch((error) => {
          this.showErrorMessage("Error", "Failed to save floor");
        });
    }

    updateCard() {
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      const { card_id, name, active } = this.state;

      const validUntilToSend = this.computeValidUntilParam();

      var url = ETVConstants.getServerBase()+"/floor_access?action=update_card";
      url+="&card_id="+card_id;
      url+="&name="+encodeURIComponent(name);
      url+="&issuer_id="+reqUserID;
      url+="&active="+active;
      url+="&location_id="+this.state.selected_location_id;
      url+="&valid_until="+encodeURIComponent(validUntilToSend);
      //console.log("update card URL="+url);

      fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then((result) => {
          this.setState({ window: '', cardsLoaded: false }); // reload table
        })
        .catch((error) => {
          this.showErrorMessage("Error", "Failed to save floor");
        });
    }

    showAccess(cardID) {
      this.setState({window:'card_access_div',selected_card_id:cardID});
    }

    formatEtvUtcToLocal(str) {
      if (!str || str.trim() === '') {
        return "Forever";
      }
      // Expecting "yyyy-MM-dd HH:mm ±HHMM"
      const re = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}) ([+-]\d{4})$/;
      const m = str.match(re);
      if (!m) return str; // fallback: show raw

      const [_, ys, ms, ds, hs, mins, off] = m;
      const y = parseInt(ys, 10);
      const mo = parseInt(ms, 10);
      const d = parseInt(ds, 10);
      const h = parseInt(hs, 10);
      const mi = parseInt(mins, 10);

      const sign = off[0] === '-' ? -1 : 1;
      const offHours = parseInt(off.substring(1, 3), 10);
      const offMins = parseInt(off.substring(3, 5), 10);
      const totalOffsetMin = sign * (offHours * 60 + offMins);

      // Calculate true UTC
      const msUTC = Date.UTC(y, mo - 1, d, h, mi) - (totalOffsetMin * 60 * 1000);
      const dt = new Date(msUTC);

      // Compare with now
      const now = new Date();
      if (dt.getTime() <= now.getTime()) {
        return "Expired";
      }

      // Display in local time
      return dt.toLocaleString(); // or format explicitly
    }

    dataURLtoBlob = async (dataUrl) => {
      if (dataUrl instanceof Blob) return dataUrl; // already Blob
      const res = await fetch(dataUrl);
      return await res.blob();
    };

    async uploadPhotos(locationID, cardID, photos) {
      try {
        if (!Array.isArray(photos) || photos.length !== 3) {
          throw new Error("Need exactly 3 photos");
        }
        if (!locationID && locationID !== 0) throw new Error("Missing location_id");
        if (!cardID) throw new Error("Missing card_id");

        this.showInfoMessage("info", ETVConstants.trans("uploading"), true);

        const accessToken = localStorage.getItem("etv.access_token");
        const reqUserID   = localStorage.getItem("etv.user_id");
        const url         = ETVConstants.getServerBase() + "/access_mgmt_image_uploader";

        // Convert dataURLs into Blobs
        const [b1, b2, b3] = await Promise.all(photos.map(p => this.dataURLtoBlob(p)));

        // Build formData exactly as backend expects
        const formData = new FormData();
        formData.append("card_id", String(cardID));
        formData.append("location_id", String(locationID));
        formData.append("photo1", b1, "photo1.jpg");
        formData.append("photo2", b2, "photo2.jpg");
        formData.append("photo3", b3, "photo3.jpg");

        // Don’t set Content-Type manually → Axios will handle it with boundary
        const config = {
          headers: {
            "user_id": String(reqUserID),
            "access_token": accessToken
          }
        };

        const response = await axios.post(url, formData, config);

        if (response.status === 200) {
          this.showSuccessMessage("upload", "uploaded to cloud storage");
          this.setState({cardsLoaded:false});
          return response.data;
        } else {
          throw new Error("Upload failed with status " + response.status);
        }

      } catch (error) {
        this.showErrorMessage("error", "error: " + (error.response?.data?.error || error.message));
        throw error;
      }
    }

    addPhoto(cardID) {
        this.setState({window:'add_photo_div',selected_card_id:cardID});
    }

    sendFace(cardID) {
      this.showInfoMessage("face","submitting the face images",true);
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      var url = ETVConstants.getServerBase()+"/floor_access?action=send_face";
      url+="&card_id="+encodeURIComponent(cardID);
      url+="&location_id="+this.state.selected_location_id;
      //console.log("send face URL="+url);
      fetch(url,{headers: { 'user_id': reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then((result) => {
          this.showSuccessMessage("sent","submitted");
        })
        .catch((error) => {
          this.showErrorMessage("Error", "Failed to save floor");
        });
    }

	  render() {
      var selectedCard = null;
      if(this.state.selected_card_id !== null) {
        selectedCard =  this.getCard(this.state.selected_card_id);
      }
	  const searchText = (this.state.cardSearch || '').trim().toLowerCase();
	  const cardsToShow = (Array.isArray(this.state.cards) ? this.state.cards : []).filter((card) =>
		!searchText ||
		String(card.card_id || '').toLowerCase().includes(searchText) ||
		String(card.name || '').toLowerCase().includes(searchText)
	  );
		  return (
		<ETVPage width="standard" icon={<Lock fontSize="large"/>} title={ETVConstants.trans("card_management")} description="Manage access cards for the selected building." loading={this.state.cardsLoading}
		  topActions={this.state.selected_location_id?<Button variant="contained" startIcon={<Add/>} onClick={()=>this.addCard()}>{ETVConstants.trans("add_card")}</Button>:null}>
          <div style={{ padding:'16px 0', width:'100%', maxWidth:500 }}>
            <Autocomplete
              options={this.state.locations}
              getOptionLabel={(option) => option.name}
              value={
                this.state.locations.find(
                  (loc) => loc.location_id === this.state.selected_location_id
                ) || null
              }
              onChange={(event, newValue) => {
                this.setState({
                  selected_location_id: newValue ? newValue.location_id : '',
                  cardsLoaded: false,
                });
              }}
              isOptionEqualToValue={(option, value) =>
                option.location_id === value.location_id
              }
              loading={this.state.loadingLocations} 
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={ETVConstants.trans("select_location")}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {this.state.loadingLocations ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </div>

          {this.state.selected_location_id?
		  <Box>
			<Box sx={{display:'flex',justifyContent:'flex-end',mb:1.5}}>
			  <TextField size="small" label="Search cards" value={this.state.cardSearch}
				onChange={(event)=>this.setState({cardSearch:event.target.value})} sx={{width:260}}/>
			</Box>
			<TableContainer component={Paper} variant="outlined" sx={{borderRadius:3,boxShadow:'none'}}>
			  <Table size="small" aria-label="Access cards">
				<TableHead>
				  <TableRow sx={{'& th':{backgroundColor:'#e3f2fd',color:'#0d47a1',fontWeight:700,borderBottom:'2px solid #1565c0',whiteSpace:'nowrap'}}}>
					<TableCell>Card ID</TableCell><TableCell>Name</TableCell><TableCell align="center">Active</TableCell>
					<TableCell>Valid until</TableCell><TableCell align="center">Access</TableCell><TableCell align="center">Actions</TableCell>
				  </TableRow>
				</TableHead>
				<TableBody>
				  {cardsToShow.map((card) => (
					<TableRow key={String(card.card_id)} hover>
					  <TableCell>{String(card.card_id || '')}</TableCell>
					  <TableCell>{String(card.name || '')}</TableCell>
					  <TableCell align="center">{card.active?<CheckCircle color="success"/>:<Block color="error"/>}</TableCell>
					  <TableCell>{card.valid_until ? this.formatEtvUtcToLocal(String(card.valid_until)) : 'Forever'}</TableCell>
					  <TableCell align="center"><Button disabled={!card.active} variant="contained" size="small" startIcon={<Lock/>} onClick={()=>this.showAccess(card.card_id)}>Access</Button></TableCell>
					  <TableCell align="center" sx={{whiteSpace:'nowrap'}}>
						<IconButton size="small" color="primary" title="Edit" onClick={()=>this.editCard(card.card_id)}><Edit/></IconButton>
						<IconButton size="small" color="primary" title="Add photo" onClick={()=>this.addPhoto(card.card_id)}><Photo/></IconButton>
						<IconButton size="small" color="primary" title="Send faces" onClick={()=>this.sendFace(card.card_id)}><Person/></IconButton>
						<IconButton size="small" color="error" title="Delete" onClick={()=>this.deleteCard(card.card_id)}><Delete/></IconButton>
					  </TableCell>
					</TableRow>
				  ))}
				  {cardsToShow.length===0 && <TableRow><TableCell colSpan={6} align="center" sx={{py:4,color:'text.secondary'}}>No cards found</TableCell></TableRow>}
				</TableBody>
			  </Table>
			</TableContainer>
		  </Box>
          :
          <span/>
          }

          <ETVPopup
            open={this.state.window === 'card_access_div'}
            width="standard"
            onClose={() => this.setState({ window: '' })}
            icon={<Lock/>}
            title="Edit access floors"
            description="Choose which private floors this card may access."
            bottomActions={<ETVActionButton action="cancel" label="Close" onClick={() => this.setState({ window: '' })}/>}
          >
            <CardAccessMgmt location_id={this.state.selected_location_id} card_id={this.state.selected_card_id} />
          </ETVPopup>

          <ETVPopup
            open={this.state.window === 'add_photo_div'}
            width="standard"
            onClose={() => this.setState({ window: '' })}
            icon={<Photo/>}
            title={ETVConstants.trans("add_update_face_photos")}
            description="Review and update the face-recognition photos for this card."
            bottomActions={<ETVActionButton action="cancel" label="Close" onClick={() => this.setState({ window: '' })}/>}
          >
              <Grid container spacing={3}>
                {/* Left: current photos */}
                <Grid item xs={12} md={5}>
                  <Stack spacing={1}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {ETVConstants.trans("current_photos")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {ETVConstants.trans("you_can_keep_or_capture_new_photos")}
                    </Typography>

                    <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
                      <PhotoThumb src={selectedCard?.photo1} alt="Photo 1" />
                      <PhotoThumb src={selectedCard?.photo2} alt="Photo 2" />
                      <PhotoThumb src={selectedCard?.photo3} alt="Photo 3" />
                    </Stack>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ p: 1, bgcolor: 'action.hover', borderRadius: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {ETVConstants.trans("tip_good_lighting_look_straight_ahead_and_align_your_face_inside_the_guide")}
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>

                {/* Right: camera / capture */}
                <Grid item xs={12} md={7}>
                  <Stack spacing={1}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {ETVConstants.trans("capture_3_new_photos")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {ETVConstants.trans("press_capture_three_times_then_press_upload_to_save")}
                    </Typography>

                    <Box sx={{ mt: 1 }}>
                      <Phototaker
                        location_id={this.state.selected_location_id}
                        card_id={this.state.selected_card_id}
                        photosTaken={this.uploadPhotos} 
                      />
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
          </ETVPopup>    

          <ETVPopup
            open={this.state.window === 'add_card_div'}
            width="small"
            onClose={() => this.setState({ window: '' })}
            icon={this.state.action === 'add_card'?<Add/>:<Edit/>}
            title={this.state.action === 'add_card' ? ETVConstants.trans('add_card') : ETVConstants.trans('edit_card')}
            description="Enter the card details and choose how long it remains valid."
            bottomActions={<>
              <ETVActionButton action="cancel" onClick={() => this.setState({ window: '' })}/>
              <ETVActionButton action="save" label={this.state.action === 'add_card'?'Save card':'Update card'}
                disabled={!this.state.card_id || !this.state.name}
                onClick={() => this.state.action === 'add_card' ? this.submitAddCard() : this.updateCard()}/>
            </>}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField
                label={ETVConstants.trans("card_id")}
                variant="outlined"
                fullWidth
                autoFocus
                value={this.state.card_id || ''}
                onChange={(e) => this.setState({ card_id: e.target.value })}
                disabled={this.state.action === 'update_card'}
              />
              <TextField
                label={ETVConstants.trans("name")}
                variant="outlined"
                fullWidth
                value={this.state.name || ''}
                onChange={(e) => this.setState({ name: e.target.value })}
              />
              <FormControlLabel
                control={
                <Switch
                  checked={Boolean(this.state.active)}
                  onChange={(e) => this.setState({ active: e.target.checked })}
                />
                }
                label={ETVConstants.trans("active")}
              />

              {/* Validity controls */}
              <FormControl component="fieldset" sx={{ mt: 1 }}>
                <FormLabel component="legend">{ETVConstants.trans("validity") || "validity"}</FormLabel>
                <RadioGroup
                  row
                  value={this.state.validityMode}
                  onChange={(e) => this.setState({ validityMode: e.target.value })}
                >
                <FormControlLabel value="never" control={<Radio />} label={ETVConstants.trans("never_expires") || "never"} />
                <FormControlLabel value="temporary" control={<Radio />} label={ETVConstants.trans("temporary") || "temporary"} />
                <FormControlLabel value="date" control={<Radio />} label={ETVConstants.trans("specific_date") || "specific date"} />
                </RadioGroup>
              </FormControl>

              {this.state.validityMode === 'temporary' && (
                <FormControl fullWidth>
                <FormLabel sx={{ mb: 1 }}>{ETVConstants.trans("duration") || "duration"}</FormLabel>
                <Select
                  value={this.state.tempMinutes}
                  onChange={(e) => this.setState({ tempMinutes: Number(e.target.value) })}
                >
                  <MenuItem value={5}>5 minutes</MenuItem>
                  <MenuItem value={15}>15 minutes</MenuItem>
                  <MenuItem value={30}>30 minutes</MenuItem>
                  <MenuItem value={60}>1 hour</MenuItem>
                  <MenuItem value={120}>2 hours</MenuItem>
                  <MenuItem value={240}>4 hours</MenuItem>
                </Select>
                </FormControl>
              )}

              {this.state.validityMode === 'date' && (
                <TextField
                label={ETVConstants.trans("valid_until") || "valid until (your local time)"}
                type="datetime-local"
                variant="outlined"
                fullWidth
                value={this.state.dateLocal}
                onChange={(e) => this.setState({ dateLocal: e.target.value })}
                InputLabelProps={{ shrink: true }}
                />
              )}
              </Box>
          </ETVPopup>

          <ETVMessagePopup type={this.state.spinning?'progress':this.state.info_type} allowClose={!this.state.spinning}
            open={this.state.window==='message_div'} onClose={this.closeInfoMessage} title={this.state.info_title} message={this.state.info_message}/>

		</ETVPage>
      );
    }
}

export default CardMgmt;
